module.exports = __webpack_public_path__ + "img/zero-logo-dark.1c0fb44f.svg";